var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('h2',[_vm._v("订单报表")])]),_c('el-row',[_c('div',{staticStyle:{"width":"100%","height":"500px"},attrs:{"id":"chart1"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }